<template>
  <div>
    <el-container>
      <el-header>
        <div class="header-content">
          <div class="header-left">
            <a href="/" class="home-a"><img src="../assets/logo.png" class="logo" width="80" /></a>
            <div style="clear: both"></div>
          </div>
          <div class="header-right">
            <div class="avatar">
              <a href="/user/center" target="_blank">
                <el-avatar :size="sizeList[1]" :src="circleUrl"></el-avatar>
              </a>
            </div>
            <router-link to="/user/center" class="username">{{
              username
            }}</router-link>
            <span class="divider">|</span>
            <a href="/user/center?ref=msg">
              <el-badge v-if="msgcount > 0" :value="msgcount" class="msg-num">
                <i class="el-icon-message"></i>
              </el-badge>
              <i v-if="msgcount == 0" class="el-icon-message"></i>
            </a>
          </div>
          <div style="clear: both"></div>
        </div>
      </el-header>
      <div style="clear: both"></div>
      <el-container>
        <el-aside width="200px">
          <el-col>
            <div>
              <el-button
                type="primary"
                icon="el-icon-edit-outline"
                @click="upload"
                >发布文章</el-button
              >
            </div>
            <div @click="choose(6)" :class="{ active: 6 == selectedIndex }">
              <router-link to="/user/info"
                ><i class="el-icon-user mr"></i>个人信息</router-link
              >
            </div>
            <div @click="choose(0)" :class="{ active: 0 == selectedIndex }">
              <router-link to="/user/comment"
                ><i class="el-icon-chat-square mr"></i>评论管理</router-link
              >
            </div>
            <!-- <div @click="choose(4)" :class="{ active: 4 == selectedIndex }">
              <router-link to="/user/playerlist"
                ><i class="iconfont icon-people mr"></i>角色管理</router-link
              >
            </div> -->
            <!-- <div @click="choose(1)" :class="{ active: 1 == selectedIndex }">
              <router-link to="/user/fans"
                ><i class="el-icon-user mr"></i>粉丝管理</router-link
              >
            </div> -->
            <div @click="choose(2)" :class="{ active: 2 == selectedIndex }">
              <router-link to="/user/datacenter"
                ><i class="el-icon-suitcase mr"></i>数据中心</router-link
              >
            </div>
            <div @click="choose(3)" :class="{ active: 3 == selectedIndex }">
              <router-link to="/user/message"
                ><i class="el-icon-chat-dot-round mr"></i>我的消息</router-link
              >
            </div>
            <div @click="choose(4)" :class="{ active: 4 == selectedIndex }">
              <router-link to="/user/articlepublish"
                ><i class="el-icon-edit-outline mr"></i>发布文章</router-link
              >
            </div>
            <div @click="choose(5)" :class="{ active: 5 == selectedIndex }">
              <router-link to="/user/articlelist"
                ><i class="el-icon-document mr"></i>文章管理</router-link
              >
            </div>
       
            <!-- <div @click="choose(6)" :class="{ active: 6 == selectedIndex }">
              <router-link to="/user/interviewqpublish"
                ><i class="el-icon-notebook-1 mr6"></i>发布面试题</router-link
              >
            </div> -->
          </el-col>
        </el-aside>
        <el-container>
          <el-main><router-view></router-view></el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "UserMain",
  data() {
    return {
      selectedIndex: 0,
      username: localStorage.getItem("name"),
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["large", "medium", "small"],
      msgcount: 0,
    };
  },
  mounted() {
    var userphoto = localStorage.getItem("userphoto");
    if (userphoto != null && userphoto != "" && userphoto!="null") {
      if (this.GLOBAL.isOnLine) {
        this.circleUrl = this.GLOBAL.baseURL + userphoto;
      } else {
        this.circleUrl = this.GLOBAL.localBaseURL + userphoto;
      }
    }
    this.$nextTick(() => {
      // 确保dom异步加载完毕
      var jumpto = this.$route.query.ref;
      if (jumpto != null && jumpto != "") {
        if (jumpto == "msg") {
          this.updateMsgToReaded();
          this.selectedIndex = 3;
          this.$router.push({ name: "message" });
        } else if (jumpto == "join") {
          this.selectedIndex = -1;
          this.$router.push({ name: "fileupload" });
        }
      } else {
        this.$router.push({ name: "comment" });
      }
    });
    this.getMsgCount();
  },
  methods: {
    upload() {
      //发布文章
      this.selectedIndex = -1;
      this.$router.push({ name: "articlepublish" });
    },
    updateMsgToReaded() {
      //更新所有消息为已读
      this.$http.post("/api/message/").catch((err) => {
        console.log(err);
      });
    },
    choose(index) {
      this.selectedIndex = index;
    },
    getMsgCount() {
      this.$http
        .get("/api/message/0")
        .then((res) => {
          this.msgcount = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
/* 覆盖原本的top属性为0 */
.msg-num > .el-badge__content.is-fixed {
  top: 22px !important;
}
</style>

<style scoped>
.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 70px;
  z-index: 11;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 5%);
  box-sizing: border-box;
}

.header-content {
  overflow: auto;
  height: 82px;
}
.header-left {
  text-align: left;
  float: left;
}
.header-right {
  float: right;
  margin-right: 20px;
}
.home-a {
  padding-top: 8px;
}
.avatar {
  float: left;
  /* padding-top: 10px; */
  padding-top:0px;
  position: inherit;
}
.username {
  font-size: 18px;
}
.divider {
  margin-left: 8px;
  margin-right: 8px;
  color: #ccc;
}
.header-right i {
  font-size: 18px;
  cursor: pointer;
}
.header-left a:hover,
.header-right a:hover {
  background-color: white;
}

.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  border-right: 1px solid #f4f4f4;
}

.el-main {
  background-color: #fafafa;
  color: #333;
  text-align: center;
}
body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.logo {
  float: left;
}
.el-col div {
  padding: 16px;
}
a {
  padding: 8px;
  font-size: 14px;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  background-color: lightgray;
}
a > i {
  font-size: 20px;
  vertical-align: baseline;
}
.mr {
  margin-right: 16px;
}
.mr8{margin-right: 8px;}
.mr6{margin-right:6px;}
.active a {
  color: #00a1d6;
}
</style>
